mutation deleteUserMutation($userId: ID!, $pageType: UserTypeEnum, $customerId: ID) {
  deleteUser(userId: $userId, pageType: $pageType, customerId: $customerId)
}
